import React, { useEffect, useState, useMemo } from "react";
import {
   Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,TabPane

} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import axios from "axios";
import toast from "react-hot-toast";

const ReservedView = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("1");
  const [reservedHistory, setReservedHistory] = useState([]);
  const [addStockHistory, setAddStockHistory] = useState([]);
  const [productInfo, setProductInfo] = useState(null);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${baseurl}/admin/products/product-stock-details/${id}`);
      setReservedHistory(res.data.reservedHistory);
      setAddStockHistory(res.data.addStockHistory);
      setProductInfo(res.data.product);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const reservedColumns = useMemo(() => [
  {
    Header: "Order No",
    accessor: "id",
  },
  {
    Header: "Reserved Qty",
    accessor: "quantity",
  },
  {
    Header: "Outward Qty",
    accessor: "outward_qty",
  },
  {
    Header: "Date",
    accessor: "cdate",
  },
], []);
const addStockColumns = useMemo(() => [
  {
    Header: "Invoice No",
    accessor: "inward_invoice_no",
  },
  {
    Header: "Store Name",
    accessor: "storename",
  },
  {
    Header: "Supplier",
    accessor: "supplier_name",
  },
  {
    Header: "Quantity",
    accessor: "quantity",
  },
  {
    Header: "Purchase Price",
    accessor: "purchase_price",
    Cell: ({ value }) => `₹ ${value}`,
  },
  {
    Header: "Invoice Date",
    accessor: "invoice_date",
  },
], []);



  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Manage Inventory"
          breadcrumbItem="Reserved Details"
        />

        <Row>
          <Col lg="12">

            <Nav tabs className="mb-4">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  Reserved History
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  Add Stock History
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>

              {/* Reserved History */}
              <TabPane tabId="1">
                <TableContainer
                  columns={reservedColumns}
                  data={reservedHistory}
                  isGlobalFilter={true}
                  customPageSize={10}
                  className="custom-header-css"
                />
              </TabPane>

              {/* Add Stock History */}
              <TabPane tabId="2">
                <TableContainer
                  columns={addStockColumns}
                  data={addStockHistory}
                  isGlobalFilter={true}
                  customPageSize={10}
                  className="custom-header-css"
                />
              </TabPane>

            </TabContent>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReservedView;
